'use client'

import { useConsentManager } from '@c15t/nextjs'

/**
 * Consent hook for advertising pixels (Meta / Facebook Pixel, TikTok Pixel).
 *
 * Advertising pixels fall under the `marketing` consent category.
 * Returns `enabled: true` only after the user grants marketing consent.
 */
export function usePixelConsent() {
  const { has } = useConsentManager()

  return {
    /** Whether Meta Pixel and TikTok Pixel may be loaded */
    enabled: has('marketing'),
  }
}
